import { createModal } from '/@/core/elements/modal'
import { type Client } from '/@/common/clients/types'

export interface ClientInfoModalData {
  client: Pick<Client, 'id' | 'firstName' | 'lastName' | 'email'> | null
  onSubmit:
    | ((client: Pick<Client, 'firstName' | 'lastName' | 'email'>) => void)
    | null
}

const { api, component } = createModal<ClientInfoModalData>(
  'ClientInfoModal',
  () => import('./ClientInfoModal.vue'),
  {
    client: null,
    onSubmit: null,
  },
)

export const useClientInfoModal = api
export default component
